///all in one
import axios from "@/axios";
export const auth = {};

export const authGetters = {
  getAuth: state => {
    return state.auth;
  },
  getAuthRole: state => {
    return (typeof state.auth.user != "undefined" )? state.auth.user.role : [];
  },
  getAuthToken: state => {
    return state.auth.access_token;
  },
  getAvatar: state => {
    return state.auth.user.avatar;
  },
  getParticipant: state => {
    // if (typeof state.auth.user != "undefined") {
    //   if (typeof state.auth.user.participant != "undefined") {
    //     return state.auth.user.participant.participant_type == 2
    //       ? {}
    //       : state.auth.user.participant;
    //   } else {
    //     return {};
    //   }
    // } else {
    //   return {};
    // }

    return typeof state.auth.user != "undefined"
      ? typeof state.auth.user.participant != "undefined"
        ? state.auth.user.participant
        : {}
      : {};
  }
};

export const authMutations = {
  changeAuthCode(state, value) {
    state.auth = value;
  },
  changeAuthUser(state, value) {
    state.auth.user = value;
  },
  changeAvatar(state, value) {
    state.auth.user.avatar = value;
  },
  changeParticipant(state, value) {
    state.auth.user.participant = value;
  }
};

export const authActions = {
  act_login: async ({ commit }, payload) => {
    try {
      let response = await axios.post("identification", payload.data);
      commit("changeAuthCode", response.data);
      return { success: true, data: response.data };
    } catch (error) {
      console.log('it is error action');
      return { success: false, message: error.response.data.message };
    }
  },
  act_changeAuth: ({ commit }, payload) => {
    commit("changeAuthCode", payload);
  },
  act_logoutAuth: ({ commit }) => {
    commit("changeAuthCode", {});
  },
  act_changeavatar: ({ commit }, payload) => {
    commit("changeAvatar", payload);
  },
  act_changeUser: ({ commit }, payload) => {
    commit("changeAuthUser", payload);
  },
  act_changeParticipant: ({ commit }, payload) => {
    commit("changeParticipant", payload);
  },
};
